import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';

import {
  Container,
  Collapse,
  Navbar,
  NavbarToggler,
  Nav,
  NavItem,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu
} from 'reactstrap';

import './Header.module.scss';
import Logo from '@assets/images/header-logo.png';
import connect from 'react-redux/es/connect/connect';
import isAllowed from '@src/auth';
import Auth from '@src/components/Elements/Auth/Auth';

class Header extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
    console.log(props);
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  render() {
    const settingsAllowed =
      isAllowed({
        action: 'Settings::tenant'
      }) ||
      isAllowed({
        action: 'Settings::users'
      });
    return (
      <header style={{backgroundColor: '#2B343B'}}>
        <Container>
          <Navbar expand="md" className={'py-0'}>
            <Link className={'navbar-brand'} to="/">
              <img src={Logo} alt={'Roy Palacios'} className={'img-fluid'} style={{height: '80px'}} />
            </Link>
            <NavbarToggler onClick={this.toggle} />
            <Collapse isOpen={this.state.isOpen} navbar>
              <Nav className="ml-auto" navbar>
                <NavItem active={this.props.activeMenu === 'eois'}>
                  <Link to={'/eois'} className={'nav-link'}>
                    EOIs
                  </Link>
                </NavItem>
                <NavItem active={this.props.activeMenu === 'associations'}>
                  <Link to={'/associations'} className={'nav-link'}>
                    Associations
                  </Link>
                </NavItem>
                <UncontrolledDropdown
                  nav
                  inNavbar
                  className={
                    this.props.activeMenu === 'companies' ? 'active' : ''
                  }
                >
                  <DropdownToggle nav caret>
                    Companies
                  </DropdownToggle>
                  <DropdownMenu right>
                    <Link
                      to={'/management-companies'}
                      className={'dropdown-item'}
                    >
                      Management
                    </Link>
                    <Link to={'/developers'} className={'dropdown-item'}>
                      Developers
                    </Link>
                    <Link to={'/carriers'} className={'dropdown-item'}>
                      Carriers
                    </Link>
                    <Link to={'/lenders'} className={'dropdown-item'}>
                      Lenders
                    </Link>
                    <Link to={'/escrow-companies'} className={'dropdown-item'}>
                      Escrow Companies
                    </Link>
                  </DropdownMenu>
                </UncontrolledDropdown>
                {settingsAllowed && (
                  <UncontrolledDropdown
                    nav
                    inNavbar
                    className={
                      this.props.activeMenu === 'settings' ? 'active' : ''
                    }
                  >
                    <DropdownToggle nav caret>
                      Settings
                    </DropdownToggle>
                    <DropdownMenu right>
                      <Auth action={'Settings::tenant'}>
                        <Link
                          to={'/settings/details'}
                          className={'dropdown-item'}
                        >
                          Details
                        </Link>
                      </Auth>
                      <Auth action={'Settings::users'}>
                        <Link
                          to={'/settings/users'}
                          className={'dropdown-item'}
                        >
                          Users
                        </Link>
                      </Auth>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                )}

                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle nav caret>
                    <FontAwesomeIcon icon={['fas', 'user-circle']} />{' '}
                    {this.props.name}
                  </DropdownToggle>
                  <DropdownMenu right>
                    <Link to={'/my-account'} className={'dropdown-item'}>
                      Manage My Account
                    </Link>
                    <Link to={'/logout'} className={'dropdown-item'}>
                      Logout
                    </Link>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>
          </Navbar>
        </Container>
      </header>
    );
  }
}
const mapStateToProps = state => {
  return {
    name: state.auth.name
  };
};
export default connect(
  mapStateToProps,
  null
)(Header);
